import { MutationTree } from 'vuex';
import { RoleState } from './types';
import { RoleResource } from '@/api/requests/types';
import { SingleFilter } from '@/store/types';

export const mutations: MutationTree<RoleState> = {
    /**
     * Add a role to the list.
     *
     * @param state
     * @param role
     */
    addRole(state, role: RoleResource) {
        const index = state.roles.findIndex((item) => item.id === role.id);
        if (index > -1) {
            state.roles.splice(index, 1, role);
        } else {
            state.roles.push(role);
        }
    },

    /**
     * Remove a role from the list.
     *
     * @param state
     * @param roleId
     */
    removeRole(state, roleId) {
        state.roles = state.roles.filter((role) => role.id !== roleId);
    },

    /**
     * Reset the active role id.
     *
     * @param state
     */
    resetActiveRoleId(state) {
        state.activeRoleId = null;
    },

    /**
     * Reset the roles list.
     *
     * @param state
     */
    resetRoles(state) {
        state.roles = [];
    },

    /**
     * Set the active role id.
     *
     * @param state
     * @param id
     */
    setActiveRoleId(state, id: number) {
        state.activeRoleId = id;
    },

    /**
     * Set the roles list.
     *
     * @param state
     * @param roles
     */
    setRoles(state, roles) {
        state.roles = roles;
    },

    /** Filters */

    /**
     * Set a query filter in state.
     *
     * @param state
     * @param key
     * @param value
     */
     setFilter(state, { key, value }: SingleFilter) {
        state.filters = { ...state.filters, [key]: value };
    },

    /**
     * Reset a single filter.
     *
     * @param state
     * @param key
     */
    resetFilter(state, key: string) {
        delete state.filters[key];
    },

    /**
     * Reset query filters.
     *
     * @param state
     */
    resetFilters(state) {
        state.filters = {};
    },
};
